import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppointmentState } from './appointment.reducer';

export const selectAppointmentState =
  createFeatureSelector<AppointmentState>('appointment');

export const selectUpcomingAppointments = createSelector(
  selectAppointmentState,
  (state: AppointmentState) => state.upcomingAppointments
);

export const selectUpcomingAppointmentsLoading = createSelector(
  selectAppointmentState,
  (state: AppointmentState) => state.isLoading
);

export const selectUpcomingAppointmentsError = createSelector(
  selectAppointmentState,
  (state: AppointmentState) => state.error
);

export const selectAppointmentById = (appointmentId: string) =>
  createSelector(selectUpcomingAppointments, (appointments) =>
    appointments.find((appointment) => appointment.id === appointmentId)
  );

